/**
 * Footer component
 */

import { Logo } from '../common/Logo';
import footerData from '@/data/footer.json';
import generalData from '@/data/general.json';

const currentYear = new Date().getFullYear();

export function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="columns is-multiline mb-6">
          {/* Company Info */}
          <div className="column is-6-mobile is-3-desktop">
            <div style={{ marginBottom: '1rem' }}>
              <Logo variant="footer" />
            </div>
            <p style={{ color: 'var(--color-gray-400)', marginBottom: '1rem' }}>
              Especialistas em aplicação de relva sintética de alta qualidade em Portugal.
            </p>
            {/* Livro de Reclamações */}
            <a
              href="https://www.livroreclamacoes.pt/Inicio/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0.5rem',
                background: 'transparent',
                borderRadius: '0.5rem',
                textDecoration: 'none',
                transition: 'all 0.3s',
                opacity: 0.8
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = '1';
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = '0.8';
                e.currentTarget.style.transform = 'scale(1)';
              }}
              aria-label="Livro de Reclamações"
            >
              <img
                src="/livro_reclamacoes.png"
                alt="Livro de Reclamações"
                style={{ width: '100px', height: 'auto' }}
              />
            </a>
          </div>

          {/* Quick Links */}
          <div className="column is-6-mobile is-3-desktop">
            <h4 className="footer-title" style={{ marginBottom: '0.5rem', marginTop: '0.5rem' }}>Links Rápidos</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '0.5rem' }}>
                <a href="#home" className="footer-link">
                  Início
                </a>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <a href="#about" className="footer-link">
                  Sobre Nós
                </a>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <a href="#services" className="footer-link">
                  Serviços
                </a>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <a href="#portfolio" className="footer-link">
                  Portfólio
                </a>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <a href="/privacy" className="footer-link">
                  Política de Privacidade
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="column is-6-mobile is-3-desktop">
            <h4 className="footer-title" style={{ marginBottom: '0.5rem', marginTop: '0.5rem' }}>Serviços</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '0.5rem' }}>
                <a href="#services" className="footer-link">
                  Jardins Residenciais
                </a>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <a href="#services" className="footer-link">
                  Áreas de Piscina
                </a>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <a href="#services" className="footer-link">
                  Espaços Comerciais
                </a>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <a href="#services" className="footer-link">
                  Campos Desportivos
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="column is-6-mobile is-3-desktop">
            <h4 className="footer-title">Contacto</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, color: 'var(--color-gray-400)' }}>
              <li style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                <svg style={{ width: '20px', height: '20px', color: 'var(--color-lime-500)' }} fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                <a href="tel:+351913225858" className="footer-link" style={{ color: 'var(--color-gray-400)' }}>
                  +351 913 225 858
                </a>
              </li>
              <li style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                <svg style={{ width: '20px', height: '20px', color: 'var(--color-lime-500)' }} fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                <a href="mailto:geral@magreen.pt" className="footer-link" style={{ color: 'var(--color-gray-400)' }}>
                  geral@magreen.pt
                </a>
              </li>
              <li style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                <svg style={{ width: '20px', height: '20px', color: 'var(--color-lime-500)' }} fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                <span>Ourém, Portugal</span>
              </li>
            </ul>

            {/* Social Links */}
            <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
              <a
                href={generalData.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="button"
                style={{
                  width: '3rem',
                  height: '3rem',
                  background: '#ffffff',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: 'none',
                  transition: 'all 0.3s',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'var(--color-lime-500)';
                  e.currentTarget.style.transform = 'scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#ffffff';
                  e.currentTarget.style.transform = 'scale(1)';
                }}
                aria-label="Facebook"
              >
                <svg style={{ width: '24px', height: '24px', color: 'var(--color-gray-700)' }} fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a
                href={generalData.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="button"
                style={{
                  width: '3rem',
                  height: '3rem',
                  background: '#ffffff',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: 'none',
                  transition: 'all 0.3s',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'var(--color-lime-500)';
                  e.currentTarget.style.transform = 'scale(1.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#ffffff';
                  e.currentTarget.style.transform = 'scale(1)';
                }}
                aria-label="Instagram"
              >
                <svg style={{ width: '24px', height: '24px', color: 'var(--color-gray-700)' }} fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

                {/* Bottom Bar */}
                <div className="footer-bottom" style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '1rem',
                    position: 'relative'
                }}>
                    <div style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
                        <p style={{ margin: 0, fontSize: '0.875rem', color: 'var(--color-gray-600)' }}>
                            {footerData.left_text.replace('{year}', currentYear.toString())}
                        </p>
                    </div>
                    {footerData.center_text && (
                        <div style={{ flex: 1, minWidth: 0, textAlign: 'center' }}>
                            <p style={{ margin: 0, fontSize: '0.875rem', color: 'var(--color-gray-600)' }}>
                                {footerData.center_text.replace('{year}', currentYear.toString())}
                            </p>
                        </div>
                    )}
                    <div style={{ flex: 1, minWidth: 0, textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '1rem' }}>
                        <p style={{ margin: 0, fontSize: '0.875rem', color: 'var(--color-gray-600)' }}>
                            {footerData.right_text.replace('{year}', currentYear.toString())}
                        </p>
                        <button
                            onClick={() => {
                                window.open('/admin/', '_blank');
                            }}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: 'var(--color-gray-600)',
                                cursor: 'pointer',
                                fontSize: '0.7rem',
                                opacity: 0.4,
                                padding: 0,
                                flexShrink: 0
                            }}
                            aria-label="Admin"
                        >
                            ⚙
                        </button>
                    </div>
                </div>
            </div>
        </footer>
    );
}
